import { ExternalDocument } from "../../../../data/model"

export const isDocumentRelated = (externalDocumentId?: number, externalDocs?: ExternalDocument[]) => {
    return externalDocumentId && externalDocs?.some((x) => x.relatedExternalSystemId === externalDocumentId)
}
